// axios
import axios from "axios";
const baseURL = "https://staff.mbsi.com.ph";


export default axios.create({
  baseURL: baseURL,
  // You can add your headers here
});
